
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supertokens",
      function () {
        return require("private-next-pages/supertokens.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supertokens"])
      });
    }
  